import {
  profiles,
  studiesIds,
  unauthorizedStudyStatus,
} from "../../modules/constants";
import FAOD401AdminLanding from "../../pages/FAOD401/Admin/Landing";
import FAOD401ParticipantLanding from "../../pages/FAOD401/Participant/Landing";
import FAOD401Stats from "../../pages/FAOD401/Stats";
import FAOD401Favorites from "../../pages/FAOD401/Participant/Favorites";
import FOAD401Management from "../../pages/FAOD401/Admin/Management";
import FAOD401DataComments from "../../pages/FAOD401/Admin/DataComments";

export default [
  {
    path: "/study",
    genericRoute: true,
    authorize: [
      profiles.participant,
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    redirectNonAuthorized: "/unauthorized",
    study: studiesIds.lcfaod401,
  },
  {
    path: "/participant",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod401,
    redirectNonStudyEnrolled: "/accessdenied",
    component: FAOD401ParticipantLanding,
    authorize: [profiles.participant],
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
    study: studiesIds.lcfaod401,
    /**
     * Removing studyIds breaks some of the internal components of the base component
     * these are still used to compare stuff in the sub-component's render.
     * These components need to be updated to not use studyId as a comparsion.
     * For exemple Sidebar stops showing any buttons if studyIds are not used.
     * study: studiesIds.lcfaod401,
     */
  },
  {
    path: "/admin",
    component: FAOD401AdminLanding,
    authorize: [
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
    study: studiesIds.lcfaod401,
  },
  {
    path: "/stats/:participantId?",
    component: FAOD401Stats,
    authorize: [
      profiles.participant,
      profiles.dietitian,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    redirectNonAuthorized: "/unauthorized",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod401,
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
    study: studiesIds.lcfaod401,
  },
  {
    path: "/favorites",
    component: FAOD401Favorites,
    authorize: [profiles.participant],
    study: studiesIds.lcfaod401,
    redirectNonAuthorized: "/unauthorized",
    unauthorizedStudyStatus: unauthorizedStudyStatus.lcfaod401,
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/data-comments",
    component: FAOD401DataComments,
    authorize: [profiles.pi, profiles.medicalMonitor],
    study: studiesIds.lcfaod401,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/management",
    component: FOAD401Management,
    authorize: [profiles.itAdmin],
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: false,
  },
];
